import React from 'react'

import TtFormik from '../../../../../global/formik-forms'
import { useParticipant } from '../../../../../webrtc/webRTCRoom'
import type { FocusConfiguration } from '../../FocusConfigurator'

interface FocusPanelModeParticipantOptionProps {
  id: number
  side: 'left' | 'right'
  type: 'Participant' | 'Screen'
}

const FocusPanelModeParticipantOption = ({
  id,
  side,
  type,
}: FocusPanelModeParticipantOptionProps) => {
  const participant = useParticipant(id)

  return (
    <TtFormik.Option<FocusConfiguration>
      name={`${side}Panel${type}Ids`}
      value={id}
    >
      {participant?.name ?? id}
    </TtFormik.Option>
  )
}

export { FocusPanelModeParticipantOption }
